import { Component, DestroyRef, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ExportsMonitoringService } from 'exports/services/exports-monitoring.service';
import { ExportsMonitoringChannelDrilldownComponent } from './exports-monitoring-channel-drilldown/exports-monitoring-channel-drilldown.component';
import { ExportsMonitoringChannelOverviewComponent } from './exports-monitoring-channel-overview/exports-monitoring-channel-overview.component';

@Component({
    selector: 'app-exports-monitoring',
    imports: [ExportsMonitoringChannelDrilldownComponent, ExportsMonitoringChannelOverviewComponent],
    templateUrl: './exports-monitoring.component.html',
    styleUrl: './exports-monitoring.component.scss',
})
export class ExportsMonitoringComponent implements OnInit {
    channelId = signal<string | null>(null);

    constructor(
        private route: ActivatedRoute,
        private destroyRef: DestroyRef,
        private exportsMonitoringService: ExportsMonitoringService,
    ) {}

    ngOnInit(): void {
        this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
            const channelId = params['channelId'];
            this.channelId.set(channelId || null);
        });
    }
}
